<template>
    <div class="bg-section-home">
      <div class="row">
        <div class="col-xl-4 col-md-6 text-gray-custom container">
          <h1 class="mx-3 justifys">راه حل های هوش مصنوعی برای چالش های امروز</h1>
          <div class="mx-4 my-4 fs-5 justifys" style="padding-right: 60px;">پتانسیل هوش مصنوعی را برای متحول کردن جهان خود باز کنید. کشف کنید که چگونه راه حل های نوآورانه ما می توانند تجارت شما را متحول کنند، کارایی را افزایش دهند و شما را به سمت موفقیت سوق دهند. امروز با فناوری پیشرفته هوش مصنوعی آینده را در آغوش بگیرید.</div>
        </div>
        <div class="col-md-5">
          <img src="../../assets/img/home/Design.svg" class="w-100" alt="">
        </div>
      </div>
    </div>
    <div class="bg-gradient-custom">
      <div class="container py-5">  
        <h5>محصولات ما</h5>
        <h1 class="mt-4">چت بات هیوا</h1>
        <div class="mx-4 mt-4 fs-5 justifys" style="padding-right: 60px;">چت بات هوش مصنوعی ما عامل مکالمه هوشمندی را ارائه می دهد که از NLP پیشرفته و یادگیری ماشین پشتیبانی می کنند. شما می توانید تعامل کاربر را افزایش دهید، پشتیبانی را ساده کنید، و کارها را همراه با یکپارچگی قابل تنظیم و مقیاس پذیر با سیستم های موجود به راحتی انجام دهید.
 تجربه مشتری خود را ارتقا دهید و با هوش مصنوعی رشد کنید.</div>
          <div id="carouselExampleControlsNoTouching" class="carousel slide mt-5" data-bs-touch="false">
            <div class="carousel-inner">
              <div class="carousel-item active">
                <div class="card p-3 mx-md-5">
                  <div class="row">
                    <div class="col-lg-6">
                      <img src="../../assets/img/home/Client Image.png" class="h-100 w-100" alt="">
                    </div>
                    <div class="col-lg-6">
                      <h4 class="text-gradient mt-3">چت بات هوش مصنوعی</h4>
                      <h5 class="mt-3" style="color: #0000008c;">ویژگی های کلیدی</h5>
                      <ul class="text-gray-custom row">
                        <div class="col-sm-6">
                          <li class="my-3">اتوماسیون پیشرفته NLPTask</li>
                          <li class="my-3">یادگیری ماشین</li>
                          <li class="my-3">اینترفیس سفارشی</li>
                          <li class="my-3">تمرکز یکپارچه</li>
                        </div>
                        <div class="col-sm-6">
                          <li class="my-3">تعامل کاربر پیشرفته</li>
                          <li class="my-3">پشتیبانی کارآمد</li>
                          <li class="my-3">راه حل های مقیاس پذیر</li>
                        </div>
                        <div class="text-end pt-1">
                          <button class="btn-blue d-sm-inline d-block">دمو</button>
                          <button class="btn-bg-white d-sm-inline d-block mx-sm-3 mx-0 my-sm-0 my-3">پیشنهاد</button>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <div class="card p-3 mx-md-5">
                  <div class="row">
                    <div class="col-lg-6">
                      <img src="../../assets/img/home/Client Image.png" class="h-100 w-100" alt="">
                    </div>
                    <div class="col-lg-6">
                      <h4 class="text-gradient mt-3">چت بات هوش مصنوعی</h4>
                      <h5 class="mt-3" style="color: #0000008c;">ویژگی های کلیدی</h5>
                      <ul class="text-gray-custom row">
                        <div class="col-sm-6">
                          <li class="my-3">اتوماسیون پیشرفته NLPTask</li>
                          <li class="my-3">یادگیری ماشین</li>
                          <li class="my-3">اینترفیس سفارشی</li>
                          <li class="my-3">تمرکز یکپارچه</li>
                        </div>
                        <div class="col-sm-6">
                          <li class="my-3">تعامل کاربر پیشرفته</li>
                          <li class="my-3">پشتیبانی کارآمد</li>
                          <li class="my-3">راه حل های مقیاس پذیر</li>
                        </div>
                        <div class="text-end pt-1">
                          <button class="btn-blue d-sm-inline d-block">دمو</button>
                          <button class="btn-bg-white d-sm-inline d-block mx-sm-3 mx-0 my-sm-0 my-3">پیشنهاد</button>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <div class="card p-3 mx-md-5">
                  <div class="row">
                    <div class="col-lg-6">
                      <img src="../../assets/img/home/Client Image.png" class="h-100 w-100" alt="">
                    </div>
                    <div class="col-lg-6">
                      <h4 class="text-gradient mt-3">چت بات هوش مصنوعی</h4>
                      <h5 class="mt-3" style="color: #0000008c;">ویژگی های کلیدی</h5>
                      <ul class="text-gray-custom row">
                        <div class="col-sm-6">
                          <li class="my-3">اتوماسیون پیشرفته NLPTask</li>
                          <li class="my-3">یادگیری ماشین</li>
                          <li class="my-3">اینترفیس سفارشی</li>
                          <li class="my-3">تمرکز یکپارچه</li>
                        </div>
                        <div class="col-sm-6">
                          <li class="my-3">تعامل کاربر پیشرفته</li>
                          <li class="my-3">پشتیبانی کارآمد</li>
                          <li class="my-3">راه حل های مقیاس پذیر</li>
                        </div>
                        <div class="text-end pt-1">
                          <button class="btn-blue d-sm-inline d-block">دمو</button>
                          <button class="btn-bg-white d-sm-inline d-block mx-sm-3 mx-0 my-sm-0 my-3">پیشنهاد</button>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControlsNoTouching" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">قبل</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControlsNoTouching" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">بعد</span>
            </button>
          </div>
      </div>
    </div>
    <div class="container">
      <div class="row d-flex">
        <div class="col-md-5 text-gray-custom my-auto">
          <h6 class="mt-md-0 mt-5" style="font-weight: bold;">هوش مصنوعی</h6>
          <h1 class="mt-4">برنامه های کاربردی</h1>
          <div class="mx-4 mt-5 fs-5">پردازش زبان طبیعی (NLP): چت ربات های مجهز به هوش مصنوعی برای خدمات مشتری، دستیاران مجازی برای زمان بندی و مدیریت کار.</div>
        </div>
        <div class="col-md-7">
          <!-- <img src="../../assets/img/home/Frame.svg" class="w-100" alt=""> -->
          <video autoplay muted loop style="width: 100%;">
              <source src="../../assets/video/frame.mp4" type="video/mp4">
          </video>
        </div>
      </div>
    </div>
    <div class="section-bg py-5">
      <div class="container my-5 d-md-flex d-block">
        <div class="card p-4 text-gray-custom">
          <h3 style="color: #0000008c;">توانایی های ما</h3>
          
          <div class="row mt-5">
            <div class="col-sm-12 mt-4">
              <h6 style="border-right: solid 1.5px;padding-right: 5px;">تخصص فنی گسترده</h6>
              <div>تیم ما متشکل از کارشناسانی با دانش عمیق و گسترده در مهندسی نرم افزار، علم داده و هوش مصنوعی است.</div>
            </div>
            <div class="col-sm-12 mt-4">
              <h6 style="border-right: solid 1.5px;padding-right: 5px;">تجربه گسترده</h6>
              <div>ما تجربه زیادی در ارائه راه حل های هوش مصنوعی به مشتریان صنایع مختلف داریم و با چالش ها و الگوهای مختلف آنها آشنا هستیم.</div>
            </div>
            <div class="col-sm-12 mt-4">
              <h6 style="border-right: solid 1.5px;padding-right: 5px;">انعطاف پذیری</h6>
              <div>توانایی انطباق با نیازها و نیازهای مشتریان مختلف و ارائه راه حل های انعطاف پذیر و قابل تنظیم. </div>
            </div>         
          </div>
        </div>
        <video autoplay muted loop class="d-md-inline d-none" style="height: 550px;">
              <source src="../../assets/video/gift.mp4" type="video/mp4">
          </video>
      </div>
    </div>
    <div class="container text-gray-custom">
      <h3 style="color: #0000008c;">خدمات ما</h3>
      <div class="row col-12 my-5 pt-4">
        <div class="col-lg-1 col-3"><img src="../../assets/img/home/Vector1.svg" style="width: 70px;" alt=""></div>
        <div class="col-lg-11 col-9 my-auto"><span>پیش بینی سری های زمانی و تجزیه و تحلیل داده ها: استفاده از الگوریتم های پیشرفته هوش مصنوعی برای تجزیه و تحلیل داده های شما و پیش بینی روندها و الگوهای آینده.</span></div>
      </div>
      <div class="row col-12 my-5">
        <div class="col-lg-1 col-3"><img src="../../assets/img/home/Vector2.svg" style="width: 70px;" alt=""></div>
        <div class="col-lg-11 col-9 my-auto"><span>سیستم‌های هوش مصنوعی سفارشی برای شرکت‌ها: طراحی و پیاده‌سازی سیستم‌های هوش مصنوعی منحصر به فرد برای افزایش عملکرد و بهینه‌سازی فرآیندها برای شرکت‌ها.</span></div>
      </div>
      <div class="row col-12 my-5">
        <div class="col-lg-1 col-3"><img src="../../assets/img/home/Vector3.svg" style="width: 70px;" alt=""></div>
        <div class="col-lg-11 col-9 my-auto"><span>سفارشی سازی راه حل های هوش مصنوعی: توسعه و استقرار راه حل های هوش مصنوعی سفارشی برای مشتریان بر اساس نیازها و اهداف خاص آنها.</span></div>
      </div>
      <div class="row col-12 my-5">
        <div class="col-lg-1 col-3"><img src="../../assets/img/home/Vector4.svg" style="width: 70px;" alt=""></div>
        <div class="col-lg-11 col-9 my-auto"><span>گردآوری و برچسب گذاری داده ها: برچسب گذاری داده ها برای آموزش و بهبود مدل های هوش مصنوعی برای واحدهای تحقیقاتی.</span></div>
      </div>
    </div>
    <div class="container">
      <div class="text-center mx-auto" style="color:#0000008c;">
        _________________________________ <span class="text-gradient">مشتریان ما</span> _________________________________
      </div>
      <div class="text-center">
        <img src="../../assets/img/hiper-link/top.png" style="width: 100px;" alt="">
        <img src="../../assets/img/hiper-link/hamrah-aval.png" style="width: 200px;" alt="">
      </div>
    </div>
    <div class="container">
      <div class="row py-5">
        <h3 style="color: #0000008c;">وبلاگ</h3>
        <!-- <div id="carouselExampleControlsNoTouching1" class="carousel slide mt-5" data-bs-touch="false">
            <div class="carousel-inner pb-5">
              <div class="carousel-item active"> -->
                <div class="row">
                  <div v-for="(item,i) in Blogs" :key="i" class="col-md-4 my-3">
                    <div class="card" style="text-align: justify; cursor: pointer;" @click="router.push({name: 'blog',params: {url:item.url}})">
                      <img :src="'https://blogs.heyvageneraltrading.com/'+item.picture" class="w-100" style="border-radius: 15px; height:180px" alt="">
                      <div class="p-3">
                        <h5 class="mt-2" style="color: #0000008c;">{{ item.title }}</h5>
                        <span class="fs-6" style="color: #6f6f6f;font-size: 13px;text-align: justify;" v-html="item.description.substr(0, 200)+'...'"></span>
                        <div class="mt-1 text-start" style="color: #6f6f6f;"><font-awesome-icon icon="fas fa-calendar" />{{ item.date2 }}</div>
                        
                        <!-- <div class="mt-3 text-gray-custom">
                          <span class="tags">Design</span>
                          <span class="tags mx-3">Research</span>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <!-- </div>
                <div class="carousel-item">
                          <div class="row">
                            <div class="col-4 my-3">
                    <div class="card" style="text-align: justify;">
                      <img src="../../assets//img/home/blog1.png" class="w-100" alt="">
                      <div class="p-3">
                        <a href="">Natali Craig • 14 Jan 2022</a>
                        <h5 class="mt-2" style="color: #0000008c;">How collaboration makes us better designers</h5>
                        <span class="fs-6" style="color: #6f6f6f">Collaboration can make our teams stronger, and our individual designs better.</span>
                        <div class="mt-3 text-gray-custom">
                          <span class="tags">Design</span>
                          <span class="tags mx-3">Research</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-4 my-3">
                    <div class="card" style="text-align: justify;">
                      <img src="../../assets//img/home/blog1.png" class="w-100" alt="">
                      <div class="p-3">
                        <a href="">Natali Craig • 14 Jan 2022</a>
                        <h5 class="mt-2" style="color: #0000008c;">How collaboration makes us better designers</h5>
                        <span class="fs-6" style="color: #6f6f6f">Collaboration can make our teams stronger, and our individual designs better.</span>
                        <div class="mt-3 text-gray-custom">
                          <span class="tags">Design</span>
                          <span class="tags mx-3">Research</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-4 my-3">
                    <div class="card" style="text-align: justify;">
                      <img src="../../assets//img/home/blog1.png" class="w-100" alt="">
                      <div class="p-3">
                        <a href="">Natali Craig • 14 Jan 2022</a>
                        <h5 class="mt-2" style="color: #0000008c;">How collaboration makes us better designers</h5>
                        <span class="fs-6" style="color: #6f6f6f">Collaboration can make our teams stronger, and our individual designs better.</span>
                        <div class="mt-3 text-gray-custom">
                          <span class="tags">Design</span>
                          <span class="tags mx-3">Research</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <div class="row">
                  <div class="col-4 my-3">
                    <div class="card" style="text-align: justify;">
                      <img src="../../assets//img/home/blog1.png" class="w-100" alt="">
                      <div class="p-3">
                        <a href="">Natali Craig • 14 Jan 2022</a>
                        <h5 class="mt-2" style="color: #0000008c;">How collaboration makes us better designers</h5>
                        <span class="fs-6" style="color: #6f6f6f">Collaboration can make our teams stronger, and our individual designs better.</span>
                        <div class="mt-3 text-gray-custom">
                          <span class="tags">Design</span>
                          <span class="tags mx-3">Research</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-4 my-3">
                    <div class="card" style="text-align: justify;">
                      <img src="../../assets//img/home/blog1.png" class="w-100" alt="">
                      <div class="p-3">
                        <a href="">Natali Craig • 14 Jan 2022</a>
                        <h5 class="mt-2" style="color: #0000008c;">How collaboration makes us better designers</h5>
                        <span class="fs-6" style="color: #6f6f6f">Collaboration can make our teams stronger, and our individual designs better.</span>
                        <div class="mt-3 text-gray-custom">
                          <span class="tags">Design</span>
                          <span class="tags mx-3">Research</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-4 my-3">
                    <div class="card" style="text-align: justify;">
                      <img src="../../assets//img/home/blog1.png" class="w-100" alt="">
                      <div class="p-3">
                        <a href="">Natali Craig • 14 Jan 2022</a>
                        <h5 class="mt-2" style="color: #0000008c;">How collaboration makes us better designers</h5>
                        <span class="fs-6" style="color: #6f6f6f">Collaboration can make our teams stronger, and our individual designs better.</span>
                        <div class="mt-3 text-gray-custom">
                          <span class="tags">Design</span>
                          <span class="tags mx-3">Research</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControlsNoTouching1" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControlsNoTouching1" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button> -->
          <!-- </div> -->
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import BlogApiService from '@/ApiService/BlogApiServece';
  import { defineComponent, onMounted, ref } from 'vue';
  import { useRouter } from 'vue-router';
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
  import { library } from '@fortawesome/fontawesome-svg-core';
  import { faCalendar } from '@fortawesome/free-solid-svg-icons';
  library.add(faCalendar);

  export default defineComponent({
    components:{},
    setup(){
      const Blogs = ref()
      const router = useRouter()
  
      onMounted(() => {
        BlogApiService.getBlogList().then(({data})=>{
          Blogs.value = data.blogs.slice(0,3)              
        })
      })
  
      return{
        Blogs,
        router
      }
    }
  })
  </script>
  
  <style scoped>
  .carousel-control-prev {
      left: -70px !important;
  }
  .carousel-control-next {
      right: -70px;
  }

  .justifys {
    text-align: justify;
    text-justify: inter-word;
  }
  
  .carousel-control-next, .carousel-control-prev {
      position: absolute;
      top: 0;
      bottom: 0;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15%;
      padding: 0;
      color: #fff;
      text-align: center;
      background: 0 0;
      border: 0;
      opacity: .5;
      transition: opacity .15s ease;
  }
  @import url('/src/assets/scss/style-rtl.scss');
  </style>
  